document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.est__RcTab--Li')
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetId = tab.dataset.tab

      tabs.forEach(t => t.classList.remove('active'))
      tab.classList.add('active')

      document.querySelectorAll('.est__RcCont--Box').forEach(box => {
        box.classList.remove('show')
      })
      document.getElementById(targetId).classList.add('show')
    })
  })
})